import httpLogsRedux from '../../views/list/redux/slice'

//export redux objects
export default {
	httpLogsRedux
};